import * as React from 'react';
import { PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';
import { FormLike } from '../../../../../react-commons/hooks/useMultiForm';
import { setToDirty } from '../../ui-state/local-status/localStatusActions';
import { Form_DisplayComponentBaseView } from './Form_DisplayComponentBaseView';

export const Form_EditableViewWrapper = ({
    children,
    form,
    onSubmit,
    hideButtons
}: PropsWithChildren<{
    form: FormLike;
    onSubmit: ((e?: React.BaseSyntheticEvent | undefined) => Promise<void>) | undefined;
    hideButtons?: boolean
}>) => {
    // TODO move to DisplayBar?
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setToDirty(form.formState.isDirty));
    }, [form.formState.isDirty]);

    return (
        <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false} hideButtons={hideButtons}>
            {children}
        </Form_DisplayComponentBaseView>
    );
};
